import { Injectable } from "@angular/core";
import { BASEMysqlService } from "./_base";
@Injectable({
  providedIn: 'root'
})
export class MysqlZoom extends BASEMysqlService {

  prefix = 'zoom_'


  createMeetingPoll(request: IZoomMeetingPollCreateRequest) {

    let data: IZoomCallAPIRequest = {
      method: `/v2/meetings/${request.meetingId}/polls`,
      httpMethod: 'POST',
      data: request
    }

    return this.callAPI(data)


  }

  getPollResult(meetingId) {
    let data: IZoomCallAPIRequest = {
      method: `/v2/past_meetings/${meetingId}/polls`,
      httpMethod: 'GET'
    }

    return this.callAPI(data)

  }

  //////////////////////////////////////////////////////////////////////////////////////////

  meetingPerformBatchRegistration(meetingId, request) {
    let data: IZoomCallAPIRequest = {
      method: `/v2/meetings/${meetingId}/batch_registrants`,
      httpMethod: 'POST',
      data: request
    }

    return this.callAPI(data)

  }

  updateMeeting(request) {

    let data: IZoomCallAPIRequest = {
      method: '/v2/users/me/meetings',
      httpMethod: 'POST',
      data: request
    }

    return this.callAPI(data)

  }

  createMeeting(request: IZoomMeetingCreateRequest) {

    let data: IZoomCallAPIRequest = {
      method: '/v2/users/me/meetings',
      httpMethod: 'POST',
      data: request
    }

    return this.callAPI(data)

  }

  getMeeting(meetingId) {

    let data: IZoomCallAPIRequest = {
      method: '/v2/meetings/' + meetingId,
      httpMethod: 'GET',
    }

    return this.callAPI(data)

  }
  getMeetingRegistrants(meetingId) {

    let data: IZoomCallAPIRequest = {
      method: `/v2/meetings/${meetingId}/registrants`,
      httpMethod: 'GET',
    }

    return this.callAPI(data)

  }

  getReportMeetingParticipants(meetingId) {

    let data: IZoomCallAPIRequest = {
      method: `/v2/report/meetings/${meetingId}/participants`,
      httpMethod: 'GET',
    }

    return this.callAPI(data)

  }



  createUser(request: IZoomUserCreateRequest) {

    let data: IZoomCallAPIRequest = {
      method: '/v2/users',
      httpMethod: 'POST',
      data: request
    }

    return this.callAPI(data)

  }

  private callAPI(request: IZoomCallAPIRequest): Promise<any> {
    let data = {
      auth: this.getAuth(),
      zoomRequest: request
    }

    // console.log(data)
    return this.http.post(this.URL_BASE + this.prefix + 'call_api', data).toPromise();
  }



}

export interface IZoomCallAPIRequest {
  method: string
  httpMethod: string
  data?: IZoomMeetingCreateRequest | IZoomUserCreateRequest | IZoomMeetingPollCreateRequest
}

export interface IZoomMeetingCreateRequest {

  topic: string
  type: EZoomUserType
  start_time: Date | string
  duration: number
  password: string

  schedule_for?: string

  settings: {
    approval_type: number//0
    waiting_room: boolean
  }

}

export interface IZoomMeetingPollCreateRequest {
  meetingId: string
  title: string
  anonymous?: boolean
  poll_type: EZoomPollType

  questions: IZoomMeetingPollQuestions[]
}


export interface IZoomMeetingPollQuestions {
  type: EZoomPollQuestionType,
  answers?: string[]
  name: string
  prompts?: IZoomPrompt[]
  right_answers?: string[],
  answer_required?: boolean,
  show_as_dropdown?: boolean
  answer_min_character?: number,
  answer_max_character?: number,
  rating_max_label?: string,
  rating_max_value?: number,
  rating_min_label?: string,
  rating_min_value?: number
}

export function getEmptyQuizQuestion() {
  return {
    type: EZoomPollQuestionType.NONE,
    //answers?: string[]
    name: ''

  }
}

export interface IZoomMeetingBatchRegistrationRequest {
  auto_approve?: number
  registrants: [IZoomMeetingBatchRegistrationRequestRegistrant]
}
export interface IZoomMeetingBatchRegistrationRequestRegistrant {


  email?: string
  first_name?: string
  last_name?: string

}

export interface IZoomPrompt {
  prompt_question: string
  prompt_right_answers: string[]

}

export enum EZoomUserType {
  INSTANT = 1,
  SCHEDULED = 2,
  RECURRING_NO_FIXED_TIME = 3,
  RECURRING_FIXED_TIME = 4
}

export enum EZoomPollType {
  POLL = 1,
  ADVANCED_POLL = 2,
  QUIZ = 3
}

export enum EZoomPollQuestionType {
  NONE = '',
  SINGLE = 'single',
  MULTIPLE = 'multiple',
  MATCHING = 'matching',
  RANK_ORDER = 'rank_order',
  SHORT_ANSWER = 'short_answer',
  LONG_ANSWER = 'long_answer',
  FILL_IN_THE_BLANK = 'fill_in_the_blank',
  RATING_SCALE = 'rating_scale',

}

export interface IZoomUserCreateRequest {
  action: EZoomUserAction //Enum: 

  user_info: {

    email: string
    first_name: string
    last_name: string
    password?: string

    type: EZoomUserType
  }
}

export enum EZoomUserType {
  BASIC = 1,
  LICENSED = 2,
  ON_PREM = 3,
  NONE = 99
}

export enum EZoomUserAction {
  CREATE = "create",
  AUTO_CREATE = "autoCreate",
  CUST_CREATE = "custCreate",
  SSO_CREATE = "ssoCreate"
}


